// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewsBox-buttonFlex-hADc8 {
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	display: -webkit-box;
	font-size: 16px;
}

.NewsBox-marginLeft-q6Us5 {
	margin-left: 25px;
}

.NewsBox-bgImage-_gNAm {
	width: 100%;
	height: 100%;
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-size: contain;
	padding-top: 44%;
	background-color: var(--primary-border);
}

.NewsBox-containerTitle-HsX5G {
	color: var(--common-text-color);
	margin: 0 0 35px;
	font-weight: bold;
	font-size: 36px;
	text-align: center;
}

@media screen and (max-width: 1170px) {
	.NewsBox-containerTitle-HsX5G {
		text-align: center;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/Home/NewsBox/NewsBox.css"],"names":[],"mappings":"AAAA;CACC,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,oBAAoB;CACpB,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,4BAA4B;CAC5B,4BAA4B;CAC5B,wBAAwB;CACxB,gBAAgB;CAChB,uCAAuC;AACxC;;AAEA;CACC,+BAA+B;CAC/B,gBAAgB;CAChB,iBAAiB;CACjB,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC;EACC,kBAAkB;CACnB;AACD","sourcesContent":[".buttonFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tdisplay: -webkit-box;\n\tfont-size: 16px;\n}\n\n.marginLeft {\n\tmargin-left: 25px;\n}\n\n.bgImage {\n\twidth: 100%;\n\theight: 100%;\n\tbackground-position: 50% 50%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tpadding-top: 44%;\n\tbackground-color: var(--primary-border);\n}\n\n.containerTitle {\n\tcolor: var(--common-text-color);\n\tmargin: 0 0 35px;\n\tfont-weight: bold;\n\tfont-size: 36px;\n\ttext-align: center;\n}\n\n@media screen and (max-width: 1170px) {\n\t.containerTitle {\n\t\ttext-align: center;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonFlex": `NewsBox-buttonFlex-hADc8`,
	"marginLeft": `NewsBox-marginLeft-q6Us5`,
	"bgImage": `NewsBox-bgImage-_gNAm`,
	"containerTitle": `NewsBox-containerTitle-HsX5G`
};
module.exports = ___CSS_LOADER_EXPORT___;
